import { render, staticRenderFns } from "./SurnameVerification.vue?vue&type=template&id=f595553e&scoped=true&"
import script from "./SurnameVerification.vue?vue&type=script&lang=js&"
export * from "./SurnameVerification.vue?vue&type=script&lang=js&"
import style0 from "./SurnameVerification.vue?vue&type=style&index=0&id=f595553e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f595553e",
  null
  
)

export default component.exports